@if (isVisible()) {
  <div class="c-zendesk">
    <slotcom-button
      class="c-button--zendesk"
      (safeClick)="goToContact()"
      audioType="functionality">
    </slotcom-button>
    <div class="c-zendesk__icon">
      <span class="icons-sprite zendesk contact"></span>
    </div>
  </div>
}
